import React, { useState, useRef, useEffect } from "react";
import { Menubar } from "primereact/menubar";
import logo from '../images/easyGray.png'
import Profile from "./Homepage/profile";
import { CustomDialog } from "../utils/dialog";
import '.././Styles/HomePage.scss'
import { useNavigate } from "react-router-dom";
import LogoutButton from "./Homepage/LogOut";
import { useSelector } from "react-redux";
import StartLogin from "./StartLogin";
import { useUser } from '@clerk/react'
import { Button } from "primereact/button";
import { Sidebar } from 'primereact/sidebar';
import { isViewerCapable } from '../utils/roles';



export const Header = () => {
  const [viewContact, setViewContact] = useState(false);
  const [viewAgent, setViewAgent] = useState(false);
  const [visibleSideBar, setVisibleSideBar] = useState(false);

  //redux states
  const fetchingUser = useSelector((state) => state.user.fetchingUserRequest);


  const [state, setState] = useState({
    userDetailsAvailable: null,
  })

  // const { user, isAuthenticated, isLoading } = useAuth0();
  const { isSignedIn, user } = useUser()

  //redux states
  const userProfile = useSelector((state) => state.user.user);

  useEffect(() => {
    if (userProfile) {
      setState((state) => ({ ...state, userDetailsAvailable: userProfile }))
    } else {
      setState((state) => ({ ...state, userDetailsAvailable: null }))
    }

  }, [userProfile])


  const hideAgentDia = () => setViewAgent(false);
  const hideContactDia = () => setViewContact(false);
  const navigate = useNavigate();

  const restrictiveRoles = ["HOME_OWNER", "AGENT", "RESIDENT_AMBASSADOR", "VIEWER"].includes(state?.userDetailsAvailable?.role);


  const menuStart = () => {
    return <div className="flex gap-2 align-items-center cursor-pointer">
      <i className="pi pi-bars ml-1" style={{ fontSize: '2rem' }} onClick={() => setVisibleSideBar(true)} />
      <Sidebar visible={visibleSideBar} onHide={() => setVisibleSideBar(false)}
        header={<img src={logo} alt='Renteasii_logo' className="img-logo " onClick={() => navigate("/")} />} >

        <section className="flex flex-column">
          <div style={{ display: "flex", flexDirection: "column", marginTop: "3px" }}>
            {!!state.userDetailsAvailable && <>
              <div className="flex justify-content-start align-items-center">
                <i className="pi pi-user mb-2" style={{ fontSize: "0.8rem" }} />
                <div className="profile-btn" onClick={() => handleNavigation("/pages/profile")}>Profile</div>
              </div>
              <div className="flex justify-content-start align-items-center">
                <i className="pi pi-book mb-2" style={{ fontSize: "0.8rem" }} />
                <div className="profile-btn" onClick={() => handleNavigation("/pages/bookings")}>{isViewerCapable(state?.userDetailsAvailable?.role) ? "My Bookings" : "My Appointments"}</div>
              </div>

              {restrictiveRoles &&
                <>
                  {['HOME_OWNER', 'AGENT'].includes(state?.userDetailsAvailable?.role) &&
                    <div className="flex justify-content-start align-items-center">
                      <i className="pi pi-upload mb-2" style={{ fontSize: "0.8rem" }} />
                      <div className="profile-btn" onClick={() => handleNavigation("/pages/UploadListing")}>Upload Listing</div>
                    </div>
                  }
{['HOME_OWNER', 'AGENT'].includes(state?.userDetailsAvailable?.role) &&
                  <div className="flex justify-content-start align-items-center">
                    <i className="pi pi-building mb-2" style={{ fontSize: "0.8rem" }} />
                    <div className="profile-btn" onClick={() => handleNavigation("/pages/listings")}>My Listings</div>
                  </div>
                }
                {state?.userDetailsAvailable?.role === 'RESIDENT_AMBASSADOR' &&
                  <div className="flex justify-content-start align-items-center">
                    <i className="pi pi-clipboard mb-2" style={{ fontSize: "0.8rem" }} />
                    <div className="profile-btn" onClick={() => handleNavigation("/pages/leads")}>My Leads</div>
                  </div>
                }
                </>
              }
            </>}

          </div>
          <div className="flex justify-content-start align-items-center">
            <span className="logout"><LogoutButton /> </span>
            <i className="pi pi-power-off" style={{ fontSize: "0.8rem" }} />
          </div>
        </section>


      </Sidebar>

    </div>
  }

  const handleNavigation = (path = "") => {
    navigate(path);
    setVisibleSideBar(false);
  }

  const menuEnd = () => {
    const showRegister = isSignedIn && !state.userDetailsAvailable;

    return (
      <div className="menu-container">
        <div className="profile-wrapper" style={{ marginTop: '2.1rem' }}>
          {showRegister ? (
            /* Case 1: Signed in but needs a profile */
            <Button
              className="login-one"
              onClick={() => handleNavigation("/pages/register")}
            >
              Create a profile
            </Button>
          ) : (
            /* Case 2: General Menu */
            <ul className="home-menu-links cursor-pointer">
              <li onClick={() => handleNavigation("/homepage")}>Home</li>
              <li onClick={() => setViewContact(true)}>Contact Us</li>

              {isSignedIn ? (
                <li className="userProfile-item">
                  <Profile />
                </li>
              ) : (
                <li className="login-one">
                  <StartLogin />
                </li>
              )}
            </ul>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <Menubar className="menubar" start={menuStart} end={menuEnd} />

      <CustomDialog
        hideContactDia={hideContactDia}
        viewContact={viewContact}
        setViewContact={setViewContact}
      />

      <CustomDialog
        viewAgent={viewAgent}
        setViewAgent={setViewAgent}
        hideAgentDia={hideAgentDia}
      />
    </div>
  )
}